/** Where everything sits on the Construction Kit's 640 x 360 screen (docs/spec/07 §4). */

import {
  BLUE, DARK_GREY, GREEN, GREY, LIGHT_BLUE, LIGHT_GREEN, LIGHT_GREY, LIGHT_RED, WHITE, YELLOW,
} from '../../render/palette';

export interface Rect {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
}

export const SCREEN_W = 640;
export const SCREEN_H = 360;

export const HEADER: Rect = { x: 0, y: 0, w: 640, h: 12 };
/** The cave view's inside (its frame is one pixel outside). 30 x 12 cells at 1x, 60 x 24 at 1/2x. */
export const VIEW: Rect = { x: 4, y: 15, w: 480, h: 192 };
export const SIDE: Rect = { x: 489, y: 14, w: 148, h: 334 };
export const FORM: Rect = { x: 3, y: 211, w: 482, h: 137 };
export const STATUS: Rect = { x: 0, y: 350, w: 640, h: 10 };

/** Right panel contents. */
export const PALETTE = { x: 492, y: 27, pitch: 18, cols: 8 };
export const SIDE_COL = [492, 564] as const;
export const SIDE_BTN_W = 70;
export const SIDE_THIRD = [492, 540, 588] as const;

/** Form grid: four columns of steppers, rows 13 px apart. */
export const FORM_COLS = [7, 125, 243, 361] as const;
export const FORM_ROWS = [225, 238, 251, 264, 277, 293] as const;
export const ISSUES_Y = 315;

export function inside(r: Rect, x: number, y: number): boolean {
  return x >= r.x && y >= r.y && x < r.x + r.w && y < r.y + r.h;
}

/** The kit's colours: C64 indices only. */
export const INK = {
  panel: BLUE,
  panelText: LIGHT_BLUE,
  frame: BLUE,
  text: LIGHT_GREY,
  bright: WHITE,
  dim: GREY,
  faint: DARK_GREY,
  hot: YELLOW,
  ok: LIGHT_GREEN,
  go: GREEN,
  error: LIGHT_RED,
  warning: YELLOW,
  button: DARK_GREY,
  buttonEdge: GREY,
} as const;
